import { render, staticRenderFns } from "./student_from_fill_up_option.vue?vue&type=template&id=1974dd87&"
import script from "./student_from_fill_up_option.vue?vue&type=script&lang=js&"
export * from "./student_from_fill_up_option.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports